import { BrowserRouter, useLocation } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SandboxProvider, useSandbox } from "./context/SandboxContext";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import RoleSwitcher from "./components/RoleSwitcher";
import CustomerApp from "./roles/CustomerApp";
import WaiterApp from "./roles/WaiterApp";
import KitchenApp from "./roles/KitchenApp";
import AdminApp from "./roles/AdminApp";
import AccountingApp from "./roles/AccountingApp";
import SuperAdminApp from "./roles/SuperAdminApp";

function Shell() {
  const { role } = useSandbox();
  const apps = {
    customer: <CustomerApp />,
    waiter: <WaiterApp />,
    kitchen: <KitchenApp />,
    admin: <AdminApp />,
    accounting: <AccountingApp />,
    super_admin: <SuperAdminApp />,
  };
  return (
    <div className="min-h-screen bg-zinc-950">
      <RoleSwitcher />
      <main key={role} className="rc-pop">{apps[role] || apps.customer}</main>
    </div>
  );
}

function Gate() {
  const { user } = useAuth();
  const location = useLocation();

  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-zinc-950 text-zinc-300">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-emerald-500 border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Login />;
  return (
    <SandboxProvider initialRole={user.role}>
      <Shell />
    </SandboxProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  );
}
